import debounce from "lodash/debounce";
import { isInfiniteScrollDown } from "logview/helpers";
import { LOADING_ROW_HEIGHT } from "./LogViewTable";
const _thresholds = (tableScrollHeight, tableClientHeight, infiniteScrollDirection) => {
  const bottomThreshold = Math.round((tableScrollHeight - tableClientHeight) / 5);
  const topThreshold = LOADING_ROW_HEIGHT;
  if (isInfiniteScrollDown(infiniteScrollDirection)) {
    return {
      bottomThreshold: topThreshold,
      topThreshold: bottomThreshold
    };
  }
  return {
    bottomThreshold,
    topThreshold
  };
};
const _onTopOrBottomReach = debounce(
  ({
    bottomThreshold,
    onBottomReach,
    onTopReach,
    tableClientHeight,
    tableScrollHeight,
    tableScrollTop,
    topThreshold
  }) => {
    if (tableScrollTop <= topThreshold) {
      onTopReach();
    }
    if (tableScrollHeight - tableScrollTop - tableClientHeight <= bottomThreshold) {
      onBottomReach();
    }
  },
  100
);
const onScroll = ({
  onBottomReach,
  onTopReach,
  tableRef,
  infiniteScrollDirection,
  finishedScrollPositionUpdateRef,
  loadPrevPromiseRef
}) => {
  const tableScrollTop = tableRef.current.scrollTop;
  const tableScrollHeight = tableRef.current.scrollHeight;
  const tableClientHeight = tableRef.current.clientHeight;
  const { bottomThreshold, topThreshold } = _thresholds(tableScrollHeight, tableClientHeight, infiniteScrollDirection);
  if (finishedScrollPositionUpdateRef.current && !(loadPrevPromiseRef == null ? void 0 : loadPrevPromiseRef.current)) {
    _onTopOrBottomReach({
      bottomThreshold,
      onBottomReach,
      onTopReach,
      tableClientHeight,
      tableScrollHeight,
      tableScrollTop,
      topThreshold
    });
  }
};
export default onScroll;
